@if (card && live_streams.length > 0) {
  <ng-container [style.aspectRatio]="aspect_ratio">
    <div class="title">live</div>
    <app-carousel [config]="splideConfig">
      @for (item of live_streams; track item) {
        <app-slide>
          <div class="badge" [style.backgroundImage]="handleBackground(item)" (click)="openLink(item.id)">
            {{ handleBadge(item) }}
          </div>
        </app-slide>
      }
    </app-carousel>
  </ng-container>
}

@if (card && upcoming_streams.length > 0) {
  <ng-container [style.aspectRatio]="aspect_ratio">
    <div class="title">upcoming</div>
    <app-carousel [config]="splideConfig">
      @for (item of upcoming_streams; track item) {
        <app-slide>
          <div class="badge">
            {{ handleBadge(item) }}
          </div>
        </app-slide>
      }
    </app-carousel>
  </ng-container>
}
